import React, { Component } from "react";
import { VideoPropTypes } from "../../constants/classPropTypes";
import truncateDescription from "../../utilities/stringManipulations";

class VideoCard extends Component {
  getVideoTag = () => {
    const {
      video: { isUpcoming, isOnAir }
    } = this.props;
    const text = this.getTagText(isUpcoming, isOnAir);

    return (
      (isUpcoming || isOnAir) && (
        <div className="badge badge-preview community-video-tag">{text}</div>
      )
    );
  };

  getTagText = (isUpcoming, isOnAir) => {
    if (isOnAir) return "OnAir";
    if (isUpcoming) return "Upcoming";
    return "";
  };

  getIsTwitchLink = (url) => typeof url === 'string' && url.indexOf("twitch") > -1;

  render() {
    const { video } = this.props;
    const videoTag = this.getVideoTag();
    const isTwitch = this.getIsTwitchLink(video.url);
    const videoImg = (
      <div className="video-img">
        <div className="thumbnail-wrapper">
          <img
            src={video.thumbnailUrl}
            role="presentation"
            alt=""
            className="img-fluid"
          />
        </div>
      </div>
    );
    const videoBody = (
      <>
        <div className="community-video-title">
          <div className="title">{video?.displayTitle ? video.displayTitle : video.title}</div>
        </div>
        {video.category && (
          <div>
            <div className="label label-tag">{video.category}</div>
          </div>
        )}
        <div className="community-video-date">
          {video.scheduledStartTimeHumanized}
        </div>
        <div>{truncateDescription(video.description)}</div>
      </>
    );
    const videoLinks = (
      <div className="community-video-link" onClick={(e) => e.stopPropagation()}>
        <a
          href={video.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${video?.displayTitle ? video.displayTitle : video.title} | Watch on ${isTwitch ? "Twitch" : "YouTube"}`}
        >
          Watch on {isTwitch ? "Twitch" : "YouTube"}
        </a>
        {video.hasLinks && (
          <a
            href={video.communityLinksUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${video?.displayTitle ? video.displayTitle : video.title} | Community links`}
          >
            Community links
          </a>
        )}
      </div>
    );

    const handleCardClick = () => {
      window.open(video.url, '_blank', 'noopener,noreferrer');
    };
    const handleCardKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleCardClick();
      }
    };

    return (
      <div className="col-lg-4 col-md-6 col-sm-12 community-video-wrapper">
        <div 
          className="community-video-card" 
          onClick={handleCardClick}
          tabIndex="0"
          onKeyDown={handleCardKeyDown}
          style={{ cursor: 'pointer' }}
        >
          {videoTag}
          {videoImg}
          {videoBody}
          {videoLinks}
        </div>
      </div>
    );
  }
}

VideoCard.propTypes = {
  video: VideoPropTypes
};
VideoCard.defaultProps = {
  video: {
    url: "",
    communityLinksUrl: "",
    thumbnailUrl: "",
    description: "",
    hasLinks: false,
    displayTitle: "",
    category: ""
  }
};

export default VideoCard;
